import React, {useEffect, useState} from "react";
import {ReactComponent as CompletedStep} from "../../../assets/ProductPageIcons/CompletedStep.svg";
import crossIcon from "../../../assets/ProductPageIcons/crosIcon.svg";
import {ReactComponent as CurrentStep} from "../../../assets/ProductPageIcons/CurrentStep.svg";
import greenDot from "../../../assets/ProductPageIcons/greenDot.svg";
import {ReactComponent as IbuttonIcon} from "../../../assets/ProductPageIcons/IbuttonIcon.svg";
import InfoIcon from "../../../assets/ProductPageIcons/InfoIcon.svg";
import {ReactComponent as NextStep} from "../../../assets/ProductPageIcons/NextStep.svg";
import radioActiveBtn from "../../../assets/ProductPageIcons/radioActiveBtn.svg";
import radioBtn from "../../../assets/ProductPageIcons/radioBtn.svg";
import {ReactComponent as StepsLine} from "../../../assets/ProductPageIcons/StepsLine.svg";
// import eth_icon from "../../assets/ETH_ICON.png";
import {ReactComponent as ArrowIcon} from "../../../assets/ProductPageIcons/ArrowIcon.svg";
import clearicon from "../../../assets/ProductPageIcons/clearicon.svg";
import coin_icon from "../../../assets/ProductPageIcons/coin_icon.svg";
import ContactNumber from "../../../assets/ProductPageIcons/ContactNumber.svg";
import EmailIcon from "../../../assets/ProductPageIcons/EmailIcon.svg";
import ProfileIcon from "../../../assets/ProductPageIcons/ProfileIcon.svg";

import {Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid} from "@mui/material";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomLoadingButton from "../../../pages/Product/HelpersComponents/CustomLoadingButton";
import {applyCouponCode} from "../../../utils/helpers/APIs/CheckoutPageAPI";
import {capitalizeWords, dollarUS} from "../../../utils/helpers/string";

import apple from "../../../assets/PaymentIcons/apple.svg";
import playStore from "../../../assets/PaymentIcons/google-play.svg";
import mastercard from "../../../assets/PaymentIcons/mastercard.svg";
import visa from "../../../assets/PaymentIcons/visa.svg";
import CheckSolidGreenIcon from "../../../assets/ProductPageIcons/CheckSolidGreen.svg";
import eth_icon from "../../../assets/ProductPageIcons/ETH_ICON.png";
import nuevi from "../../../assets/ProductPageIcons/nuevi.svg";
import usdt_icon from "../../../assets/ProductPageIcons/USDT_ICON.png";

import usd_icon from "../../../assets/icons/tron-trx-logo.png";
import usd_Coin from "../../../assets/icons/usd-coin-usdc-logo.png";

import {setPlanType} from "../../../Redux/PlanSectionSlice";
import PDFPreview from "../../ReusableComponent/PDFReview/PDFReview";
import PDFDoc from "../../../assets/Docs/Alpha Capital Group - Terms and Conditions.pdf";
import zoomImg from "../../../assets/icons/imgBtn.svg";
import "./CheckoutSection.scss";
import {Modal} from "antd";

const PayoutTypeSelector = ({payout_type, selectedPayoutType, setSelectedPayoutType, fundingEval}) => {
  const [showInfo, setShowInfo] = useState(null);

  const handleMouseLeave = () => {
    setShowInfo(null);
  };

  useEffect(() => {
    if (fundingEval === "Swing") {
      const filtered = payout_type.filter((p) => p.value !== 1);
      if (filtered.length > 0) {
        setSelectedPayoutType(filtered[0].value);
      }
    }
  }, [fundingEval, payout_type, setSelectedPayoutType]);

  // Filter payout options based on fundingEval
  const filteredPayoutType = fundingEval === "Swing" ? payout_type.filter((payout) => payout.value !== 1) : payout_type;

  console.log("filteredPayoutType", payout_type, filteredPayoutType, fundingEval);

  return (
    <div className="payoutType">
      <div className="account_balance_header">
        <h2>Payout Type</h2>
      </div>
      <div className="payoutType_main">
        {filteredPayoutType?.map((payoutType, index) => {
          const isActive = payoutType.value === selectedPayoutType;

          return (
            <label
              key={payoutType.value}
              htmlFor={`payout-${payoutType.value}`}
              className={isActive ? "active_payout" : ""}
              onClick={() => setSelectedPayoutType(payoutType.value)}
              onMouseLeave={handleMouseLeave}
            >
              <img
                src={isActive ? radioActiveBtn : radioBtn}
                alt={isActive ? "Selected" : "Not Selected"}
              />
              <p>{payoutType.name}</p>
              <input
                type="radio"
                name="payoutType"
                id={`payout-${payoutType.value}`}
                checked={isActive}
                onChange={() => {}} // To silence React warning
              />
              <img
                src={InfoIcon}
                alt="Info"
                className="info-icon"
                onMouseEnter={() => setShowInfo(index)}
              />

              {showInfo === index && (
                <div className="payout_tooltip-box">
                  <p>
                    {payoutType.value === 1 ? "Payout option fixed every 14 days cycle" : "Payout requests on demand, anytime, once 2 requirements are met "}
                    {payoutType.value === 2 && (
                      <a
                        href="https://help.alphacapitalgroup.uk/en/articles/10102634-performance-fee-on-demand"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        (learn more)
                      </a>
                    )}
                  </p>
                </div>
              )}
            </label>
          );
        })}
      </div>
    </div>
  );
};

const CheckoutSection = ({challenges, selectedPlanId}) => {
  const [firstStepVisible, setFirstStepVisible] = useState(true);
  const [selectedStep, setStep] = useState(2);
  const [fundingEval, setFundingEval] = useState(false);
  const [selectedType, setSelectedtype] = useState(0);
  const [hoveredChallenge, setHoveredChallenge] = useState(null);
  const [alphaProVariant, setAlphaProVariant] = useState(8);
  const [selectedAmountBox, setSelectedAmountBox] = useState(0);
  const [selectedPrice, setSelectedPrice] = useState("50");
  const [accountBalance, setAccountBalance] = useState(false);
  const [selectedAmountFree, setSelectedAmountFree] = useState(0);
  const [countryCheck, setCountryCheck] = useState("");
  const [platformVal, setPlatformVal] = useState("MT 5");
  const [selectedPlatformBox, setSelectedPlatformBox] = useState(0);
  const [FreeTrial, setFreeTrial] = useState(false);
  const [openCryptoOptionsBD, setOpenCryptoOptionsBD] = useState(false);
  const [isCoindMethodSelected, setIsCoinMethodSelected] = useState(false);
  const [selectedCrypto, setSelectedCrypto] = useState("ETH");
  const radioGroupRef = React.useRef(null);
  const [paymentMethod, setPaymentMethod] = useState("nuvei");
  const [selectedAcType, setSelectedAcType] = useState(1);
  const [useEA, setUseEA] = useState(false);
  const [basicDetails, setBasicDetails] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [initialPlan, setInitialPlan] = useState();
  const [selectedChallengeDetails, setSelectedChallengeDetails] = useState(null);
  const [selectedPayoutType, setSelectedPayoutType] = useState(2);
  const [couponValue, setCouponValue] = useState("");
  const [showTNC, setShowTNC] = useState(false);
  const [TNC, setTNC] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const [confirmPaymentClick, setConfirmPaymentClick] = useState(false);
  const [challengePrice, setChallengePrice] = useState(null);
  const [couponCodeExist, setCouponCodeExist] = useState(false);
  const [showAlphaTooltip, setShowAlphaTooltip] = useState(false);

  const [hoveredAlphaProVariant, setHoveredAlphaProVariant] = useState(null);

  const selectedPlan = challenges;

  const {planType} = useSelector((state) => state.planSection);

  function findObjectById(data, selectedPlanId) {
    for (const key in data) {
      if (Array.isArray(data[key])) {
        for (const plan of data[key]) {
          if (plan.id === selectedPlanId) {
            return plan;
          }
        }
      }
    }
    return null; // Return null if no matching ID is found
  }

  console.log("challengePrice", challengePrice);

  let result = findObjectById(challenges, selectedPlanId);

  useEffect(() => {
    result = null;
  }, [selectedStep]);

  // Popup states
  const [showPopup, setShowPopup] = useState(false);
  const [combinedPUHead, setCombinedPUHead] = useState("");
  const [combinedPUBody, setCombinedPUBody] = useState("");
  const [popUpType, setPopUpType] = useState("");

  const [checkout, setCheckout] = useState({
    price: 0,
    discount: 0,
    final_price: 0,
  });

  const [data, setData] = useState({
    email: "",
    confirmEmail: "",
    firstName: "",
    lastName: "",
    // pwd: "",
    contact: "",
  });

  const [validEmail, setValidEmail] = useState(false);
  const [validConfirmEmail, setValidConfirmEmail] = useState(false);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  useEffect(() => {
    // Validate email
    if (emailRegex.test(data.email.trim())) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  }, [data.email]);

  useEffect(() => {
    // Validate email and check if email and confirm email match
    if (emailRegex.test(data.confirmEmail.trim()) && data.email.trim() === data.confirmEmail.trim()) {
      setValidConfirmEmail(true);
    } else {
      setValidConfirmEmail(false);
    }
  }, [data.confirmEmail, data.email]);

  const [coupon, setCoupon] = useState({
    value: "",
    error: "",
    loading: false,
  });
  const [isChecked, setIsChecked] = useState({
    tnc: false,
    not_us_resident: false,
    acknowledge_personal_data: false,
    agree_to_news_letters: false,
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const updateData = (k, v) => setData((prevState) => ({...prevState, [k]: v}));

  const platform = [
    {label: "MT 5", value: "MT 5"},
    {label: "cTrader", value: "C Trader"},
    {label: "DX Trade", value: "DX Trade"},
    {label: "TradeLocker", value: "TradeLocker"},
    {label: "Alpha Trader", value: "Alpha Trader", disabled: true},
  ];
  const ac_type = ["Raw spread", "No commission"];
  const EA = ["Yes", "No"];

  const payout_type = [
    {
      name: "Bi-Weekly",
      value: 1,
    },
    {
      name: "On demand",
      value: 2,
    },
  ];

  const filteredPlatforms =
    countryCheck && countryCheck === "US"
      ? [
          {label: "DX Trade", value: "DX Trade"},
          {label: "TradeLocker", value: "TradeLocker"},
          {label: "Alpha Trader", value: "Alpha Trader", disabled: true},
        ]
      : platform;

  const STEPS = [1, 2, 3];

  const currentChallenge = selectedChallengeDetails && selectedChallengeDetails[0];

  useEffect(() => {
    if (!currentChallenge) {
      setChallengePrice(null);
      return;
    }

    let price;

    if (fundingEval === "Alpha Pro") {
      const isAlphaPro10 = alphaProVariant === 10 || planType === "Alpha Pro10%";
      price = isAlphaPro10 ? currentChallenge?.price_alpha_pro_10per : currentChallenge?.Price;
    } else {
      price = currentChallenge?.Price;
    }

    setChallengePrice(price ?? null); // fallback if Price is undefined
  }, [currentChallenge, fundingEval, alphaProVariant, planType, data?.challenge_id, result, challenges, selectedPlanId]);

  useEffect(() => {
    if (fundingEval === "Alpha Pro") {
      if (alphaProVariant === 6) {
        dispatch(setPlanType("Alpha Pro6%"));
      } else if (alphaProVariant === 8) {
        dispatch(setPlanType("Alpha Pro8%"));
      } else {
        dispatch(setPlanType("Alpha Pro10%"));
      }
    }
  }, [alphaProVariant]);

  // useEffect(() => {
  //   if (fundingEval) {
  //     setTenPercentProfit(0);
  //   }
  // }, [fundingEval]);

  useEffect(() => {
    if (planType === "Alpha Pro10%") {
      setAlphaProVariant(10);
    } else if (planType === "Alpha Pro8%") {
      setAlphaProVariant(8);
    } else {
      setAlphaProVariant(6);
    }
  }, [planType]);

  const handleMouseEnter = (challenge) => {
    setHoveredChallenge(challenge); // Set hovered challenge
  };

  const handleMouseLeave = () => {
    setHoveredChallenge(null); // Clear hovered challenge
  };

  function handlePaymentMethod(e) {
    const id = e.currentTarget.id;
    setPaymentMethod(id);
    if (id === "coinspayment") {
      setOpenCryptoOptionsBD(true);
    }
  }
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev); // Properly toggle dropdown state
  };

  const handleTNCModal = (value) => {
    setShowTNC(TNC ? false : value);
  };

  const handleFinalPayment = async (e) => {
    e.preventDefault();

    setConfirmPaymentClick(true);

    // Validate required fields
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(data.email.trim())) {
      showToast("Please enter a valid email address", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data?.firstName || !data?.lastName) {
      showToast("Please enter your full name!", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (/\s$/.test(data.firstName) || /\s$/.test(data.lastName)) {
      showToast("Please remove the last space from your name!", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data?.contact) {
      showToast("Please enter your Contact Number", "error");
      setConfirmPaymentClick(false);
      return;
    }

    const contactRegex = /^\d{6,15}$/;
    if (!contactRegex.test(data.contact)) {
      showToast("Contact Number must be between 6 and 15 digits", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!emailRegex.test(data.confirmEmail.trim())) {
      showToast("Please enter a valid confirm email address", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!validConfirmEmail) {
      showToast("Email address does not match.", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (
      isChecked.tnc === false ||
      isChecked.acknowledge_personal_data === false ||
      (platformVal !== "DX Trade" && platformVal !== "TradeLocker" && platformVal !== "C Trader" && countryCheck !== "US" && !isChecked.not_us_resident)
    ) {
      showToast("Please accept the terms and conditions", "error");
      setConfirmPaymentClick(false);
      return;
    }

    if (!data.challenge_id) {
      showToast("Please select a plan and balance!", "error");
      setConfirmPaymentClick(false);
      return;
    }

    // Prepare payloads
    const country_code = (countryCode && countryCode.code) || "";
    const acc_creation_payload = {
      name: data.name,
      pwd: data.pwd,
      pwdInvestor: data.pwd,
      leverage: data.leverage,
      challenge: data.challenge,
      payout_type: selectedPayoutType,
      EAs: useEA,
      ...(fundingEval?.toLowerCase() === "alpha pro" ? {alpha_pro_variant: alphaProVariant} : []),

      raw_spread: selectedAcType === 0,
      email: data.email,
      platform: selectedPlatformBox === 0 ? "mt5" : selectedPlatformBox === 1 ? "ctrader" : selectedPlatformBox === 2 ? "dxtrade" : selectedPlatformBox === 3 ? "tradelocker" : false,
      agreed_to: [
        isChecked.tnc && "I declare that I have read and agree with Terms & Conditions, Privacy policy, General Service Agreement.",
        isChecked.not_us_resident && "I'm not a US resident or citizen.",
        isChecked.acknowledge_personal_data &&
          "I acknowledge that signing up with personal details that do not match my ID/Password information, will lead to suspension of my payout(s) and closure of my account(s).",
        isChecked.agree_to_news_letters && "I agree to receive newsletters, news, and product updates.",
      ].filter(Boolean),
      // country_code,
    };

    const payload = {
      email: data.email,
      first_name: data.firstName,
      last_name: data.lastName,
      contact: data.contact,
      // country_code,
      challenge_id: data.challenge_id,
      payment_method: paymentMethod,
      cryptocurrency: selectedCrypto,
      // marketing_opt_in: isChecked.marketing_opt_in ? "True" : "False",
      ...(fundingEval?.toLowerCase() === "alpha pro" ? {alpha_pro_variant: alphaProVariant} : []),

      payout_type: selectedPayoutType,
      EAs: useEA,
      raw_spread: selectedAcType === 0,
      platform: countryCheck === "US" ? "dxtrade" : selectedPlatformBox === 0 ? "mt5" : selectedPlatformBox === 1 ? "ctrader" : selectedPlatformBox === 3 ? "tradelocker" : "dxtrade",
    };

    if (coupon.value && !coupon.loading) {
      payload["coupon"] = coupon.value;
    }

    try {
      // Perform payment initialization with Axios
      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined) {
          formData.append(key, value);
        }
      });

      const {data: result} = await axios.post("https://backend.alphacapitalgroup.uk/v2/get/checkout/payment-url/", formData);

      if (result?.url) {
        console.log("Redirecting to payment URL:", result.url);

        // Redirect to the provided URL
        window.location.href = result.url;
      } else {
        throw new Error("Redirect URL not found");
      }

      if (result.auth) {
        console.log("User authenticated:", result.auth);
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      setConfirmPaymentClick(false);
      console.error("Payment initialization failed:", error);

      let errorMessage = "Something went wrong";

      if (error?.response) {
        const {data} = error.response;

        if (data?.detail) {
          errorMessage = data?.detail;
        } else if (data?.message) {
          errorMessage = data?.message;
        } else if (Array?.isArray(data) && data?.length > 0) {
          // Handle array response like ["Contact number already registered"]
          errorMessage = data[0]; // Take the first error message from the array
        } else if (data && Object?.keys(data)?.length > 0) {
          const firstKey = Object?.keys(data)[0];
          errorMessage = Array?.isArray(data[firstKey]) ? data[firstKey][0] : data[firstKey];
        }
      } else if (error?.request) {
        errorMessage = "Something went wrong";
      } else {
        errorMessage = error?.message || "Failed to initialize payment.";
      }

      showToast(errorMessage, "error");
    }
  };

  const showToast = (message, type = "info") => {
    setConfirmPaymentClick(false);
    if (toast[type]) {
      toast[type](message, {
        // position: toast.POSITION.TOP_CENTER,
        autoClose: 5000, // Auto close after 5 seconds
      });
    } else {
      console.error(`Invalid toast type: ${type}`);
    }
  };

  const [buttonSpinner, setButtonSpinner] = useState(false);

  const validateCouponCode = async () => {
    setCoupon((prevState) => ({...prevState, loading: true}));

    // if (!data?.challenge_id) {
    //   console.error("Invalid challenge ID");
    //   setCoupon((prevState) => ({...prevState, error: "Invalid challenge ID", loading: false}));
    //   return;
    // }

    const coupon_code = coupon?.value || null;

    try {
      setButtonSpinner(true);
      const platform = selectedPlatformBox === 0 ? "mt5" : selectedPlatformBox === 1 ? "ctrader" : selectedPlatformBox === 2 ? "dxtrade" : selectedPlatformBox === 3 ? "tradelocker" : false;
      const res = await applyCouponCode(data?.challenge_id, coupon_code, alphaProVariant, fundingEval, platform);

      setButtonSpinner(false);

      setCoupon((prevState) => ({...prevState, error: "", loading: false}));
      setCouponValue(coupon_code);
      setCouponCodeExist(true);

      setCheckout((prev) => ({
        price: res.actual_price,
        discount: coupon.error ? 0 : res.discount,
        final_price: coupon.error ? res.actual_price : res.discounted_price,
      }));

      setFreeTrial(res.discounted_price === 0);

      if (res.data?.coupon) {
        setCoupon(res.data.coupon);
      }
    } catch (error) {
      setButtonSpinner(false);
      const errorMessage = error?.detail || "An error occurred while applying the coupon.";
      setCoupon((prevState) => ({
        ...prevState,
        error: errorMessage,
        loading: false,
      }));
    }
  };

  useEffect(() => {
    if (platformVal === `DX Trade` || platformVal === "TradeLocker" || platformVal === "C Trader") {
      setIsChecked({ ...isChecked, not_us_resident: false });
    }
  }, [platformVal]);

  console.log("platformVal", platformVal, isChecked);

  useEffect(() => {
    const countryCheckingReq = async () => {
      try {
        const response = await fetch("https://backend.alphacapitalgroup.uk/check/country/");

        if (response.ok) {
          // Checks for status 200-299
          const data = await response.json();
          setCountryCheck(data?.country);
        }
      } catch (error) {
        console.error("Fetch Error:", error);
      }
    };

    countryCheckingReq();
  }, []);

  // useEffect(() => {
  //   challenges &&
  //     Object.keys(challenges).forEach((plan_type) => {
  //       challenges[plan_type].forEach((challenge) => {
  //         // setFundingEval(challenge.plan_type === "Alpha pro" ? "Alpha Pro" : challenge.plan_type);
  //         setAccountBalance(challenge.account_balance);
  //         setStep(challenge.steps);
  //         updateData("leverage", Number(challenge.leverage));
  //         updateData("challenge_id", challenge.id);
  //         updateData("challenge", challenge.id);

  //         return;
  //       });
  //     });
  // }, [challenges, dispatch]);

  // useEffect(() => {
  //   if (challenges) {
  //     setInitialPlan(challenges["Alpha Pro"]?.find((item) => item?.id === Number(result?.id))?.Price);
  //   }
  // }, []);

  // By default select account type when change in steps
  useEffect(() => {
    if (selectedStep && typeof challenges === "object") {
      const plans = Object.keys(challenges).filter((item) => (challenges[item].filter((itm) => itm.steps === selectedStep && !String(item).toLowerCase().includes("free")).length && item) || false);

      if (result) {
        setFundingEval(String(capitalizeWords(result?.plan_type)));
      } else {
        setFundingEval((plans.length && plans[0]) || null);
      }
    }
  }, [selectedStep, challenges, result, couponValue]);

  useEffect(() => {
    if (result) {
      setStep(result.steps);
      setFundingEval(String(capitalizeWords(result?.plan_type)));
      updateData("challenge_id", Number(selectedPlanId));
      updateData("challenge", Number(selectedPlanId));
      setAccountBalance(result?.account_balance);

      // setAccountBalance(result.account_balance);
    }
  }, [selectedPlanId, result, challenges]);

  useEffect(() => {
    updateData("challenge_id", 8);
    setFundingEval("Alpha Pro");
    setAccountBalance(challenges["Alpha Pro"]?.[1]?.account_balance);
  }, []);

  useEffect(() => {
    if (couponValue) {
      validateCouponCode();
    }
  }, [couponValue, alphaProVariant, data?.challenge_id]);

  useEffect(() => {
    if (fundingEval === "Swing" || "Alpha pro") {
      setSelectedPayoutType(2);
    }
  }, [selectedStep]);

  useEffect(() => {
    if (fundingEval && challenges) {
      let validChallenges = challenges[fundingEval] || [];

      // Special filtering for Alpha Pro variant
      if (fundingEval === "Alpha Pro" && alphaProVariant) {
        const effectiveTarget = alphaProVariant === 10 ? 8 : alphaProVariant;
        validChallenges = validChallenges.filter((challenge) => challenge.profit_target_in_percent === effectiveTarget);
      }

      // Check if current accountBalance is valid
      const isBalanceValid = validChallenges.some((challenge) => challenge.account_balance === accountBalance);

      if (!isBalanceValid && validChallenges.length > 0) {
        setAccountBalance(validChallenges[0].account_balance); // set default valid balance
        return; // wait for re-render with new accountBalance
      }

      // Filter by accountBalance
      const matchedPlans = validChallenges.filter((challenge) => challenge.account_balance === accountBalance);

      setSelectedChallengeDetails(matchedPlans);

      if (matchedPlans.length === 1) {
        updateData("leverage", Number(matchedPlans[0].leverage));
        updateData("challenge_id", matchedPlans[0].id);
        updateData("challenge", matchedPlans[0].id);
      } else {
        updateData("challenge_id", "");
        updateData("challenge", "");
      }
    }
  }, [fundingEval, accountBalance, selectedStep, challenges, selectedPrice, selectedAmountFree, alphaProVariant]);

  console.log("account_balance", accountBalance, challengePrice, currentChallenge);

  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const screenWidth = window.innerWidth;
      setScale(screenWidth < 750 ? 0.5 : 1);
    };

    updateScale(); // Set on initial load
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);

  const renderLimits = (variant) => {
    const variantData = {
      6: [
        {label: "Profit Target 1", value: "6.00%"},
        // {label: "Profit Target 2", value: "6.00%"},
        {label: "Max Loss", value: "6.00%"},
        {label: "Max Daily Loss", value: "3.00%"},
      ],
      8: [
        {label: "Profit Target 1", value: "8.00%"},
        // {label: "Profit Target 2", value: "8.00%"},
        {label: "Max Loss", value: "8.00%"},
        {label: "Max Daily Loss", value: "4.00%"},
      ],
      10: [
        {label: "Profit Target 1", value: "10.00%"},
        // {label: "Profit Target 2", value: "10.00%"},
        {label: "Max Loss", value: "10.00%"},
        {label: "Max Daily Loss", value: "5.00%"},
      ],
    };
    return (
      <div className="dropdown-content open">
        {variantData[variant]?.map((item, i) => (
          <div
            key={i}
            className="dropdown-content_inner"
          >
            <div>
              {" "}
              <img
                src={greenDot}
                alt="greenDot"
              />{" "}
              <p> {item.label}</p>
            </div>
            <div>
              <h4>{item.value}</h4>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="WPPublicCheckoutPage_main">
      <div className="WPPublicCheckoutPage_main_header">
        <h4>Product</h4>
        <h2>
          Become an <span>Alpha Trader</span>
        </h2>
      </div>

      {/* {anonymous ? (
        <div className="WPCheckoutPage_main_header_container">
          <h6>Products</h6>
          <h2>
            Become an <span className="gradient_header">Alpha Traders</span>
          </h2>
          <p>
            Choose the evaluation based on your preference to become an Alpha
            Trader.
          </p>
        </div>
      ) : (
        false
      )} */}

      {/* <div
        style={{ cursor: "pointer" }}
        className="backBtnContainer"
        onClick={() => navigate("/dashboard")}
      >
        <img style={{ width: "20px" }} src={backBtn} alt="backBtn" />
        Back
      </div> */}
      <div className="WPCheckoutPage_left_right_sec">
        <div className="account_balance">
          <div>
            <div className={`account_balance_inner ${firstStepVisible ? "firstStepVisible" : ""}`}>
              <div className="step_progress_container">
                <div className="stepProgress_heading">
                  <h3>Select Plan</h3>
                  <h3>Basic Info</h3>
                </div>
                <div className="stepProgress">
                  <div
                    className="firstProgress"
                    onClick={() => setFirstStepVisible(!firstStepVisible)}
                  >
                    {firstStepVisible ? <CurrentStep /> : <CompletedStep />}
                  </div>

                  <div className="progressLine">
                    <StepsLine />
                  </div>
                  <div
                    className="nextProgress"
                    onClick={() => setFirstStepVisible(!firstStepVisible)}
                  >
                    {firstStepVisible ? <NextStep /> : <CurrentStep />}
                  </div>
                </div>
              </div>

              <div className="checkoutContent">
                <div className="firstStep">
                  <div className="platform">
                    <div className="heading">
                      <h1
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        Step
                      </h1>
                    </div>
                    <div className="platform_main">
                      {STEPS.map((step) => (
                        <label
                          onClick={(e) => {
                            setStep(step);
                          }}
                          className={"platform_box " + (selectedStep === step && "active_label selected_box")}
                        >
                          {selectedStep === step ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}
                          <p>{step} Step</p>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="user_ac_type">
                    <div className="account_balance_header">
                      <h2>Account Type</h2>
                    </div>
                    <div className="user_ac_type_inner">
                      {challenges &&
                        Object.keys(challenges).map((challenge, i) => {
                          // Check if it's a public checkout page

                          if (challenge === "Free Trial") {
                            return null;
                          }
                          if (!challenges[challenge] || challenges[challenge].length === 0) {
                            return null;
                          }
                          if (!challenges[challenge].filter((item) => item.steps === selectedStep).length) {
                            return null;
                          }
                          return (
                            <label
                              htmlFor={challenge}
                              key={i}
                              className={String(fundingEval)?.toLowerCase() === challenge?.toLowerCase() ? "ac_type_option active_label" : "ac_type_option"}
                              onClick={() => setSelectedtype(i)}
                            >
                              <div className="label_inner_div">
                                {String(fundingEval)?.toLowerCase() === challenge?.toLowerCase() ? (
                                  <img
                                    src={radioActiveBtn}
                                    alt="radioActiveBtn"
                                  />
                                ) : (
                                  <img
                                    src={radioBtn}
                                    alt="radioBtn"
                                  />
                                )}

                                <p>{challenge}</p>

                                <input
                                  type="radio"
                                  id={challenge}
                                  name="fundingEval"
                                  value={challenge}
                                  checked={String(fundingEval)?.toLowerCase() === challenge?.toLowerCase()}
                                  onChange={(e) => setFundingEval(capitalizeWords(e.target.value) === "alpha pro" ? "Alpha Pro" : capitalizeWords(e.target.value))}
                                  // disabled={removeCoupon}
                                />
                              </div>

                              <img
                                src={InfoIcon}
                                alt="InfoIcon"
                                onMouseEnter={() => handleMouseEnter(challenge)}
                                onMouseLeave={handleMouseLeave}
                              />

                              {hoveredChallenge === challenge && (
                                <div className="tooltip-box">
                                  <div className={`dropdown-content open`}>
                                    <>
                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Leverage</p>
                                        </div>
                                        <div>
                                          <h4>{challenges[challenge]?.[0]?.Leverage ? `1:${challenges[challenge]?.[0]?.Leverage}` : "-"}</h4>
                                        </div>
                                      </div>
                                      {/* Add more dropdown content like this */}
                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Profit Target 1</p>
                                        </div>
                                        <div>
                                          <h4>
                                            {alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 10
                                              ? "10.00%"
                                              : alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 8
                                              ? "8.00%"
                                              : alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 6
                                              ? "6.00%"
                                              : challenges[challenge]?.[0]?.Evaluation_Phase_1 && challenges[challenge]?.[0]?.account_balance
                                              ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_1 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                              : "-"}
                                          </h4>
                                        </div>
                                      </div>

                                      {challenges[challenge]?.[0]?.Evaluation_Phase_2 > 0 && (
                                        <div className="dropdown-content_inner">
                                          <div>
                                            <img
                                              src={greenDot}
                                              alt="greenDot"
                                            />
                                            <p>Profit Target 2</p>
                                          </div>
                                          <div>
                                            <h4>
                                              {alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 10
                                                ? `5.00%`
                                                : alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 8
                                                ? `5.00%`
                                                : alphaProVariant && challenges[challenge]?.[0]?.plan_type === "Alpha pro" && alphaProVariant === 6
                                                ? `6.00%`
                                                : challenges[challenge]?.[0]?.Evaluation_Phase_2 && challenges[challenge]?.[0]?.account_balance
                                                ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_2 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                                : "-"}
                                            </h4>
                                          </div>
                                        </div>
                                      )}

                                      {challenges[challenge]?.[0]?.Evaluation_Phase_3 > 0 && (
                                        <div className="dropdown-content_inner">
                                          <div>
                                            <img
                                              src={greenDot}
                                              alt="greenDot"
                                            />
                                            <p>Profit Target 3</p>
                                          </div>
                                          <div>
                                            <h4>
                                              {challenges[challenge]?.[0]?.Evaluation_Phase_3 && challenges[challenge]?.[0]?.account_balance
                                                ? `${((challenges[challenge]?.[0]?.Evaluation_Phase_3 / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                                : "-"}
                                            </h4>
                                          </div>
                                        </div>
                                      )}

                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          {fundingEval === "Alpha One" ? <p>Trailing MLL</p> : <p>Max Loss</p>}
                                        </div>
                                        <div>
                                          <h4>
                                            {fundingEval === "Alpha One" && currentChallenge?.trailing_mll !== 0
                                              ? `${currentChallenge?.trailing_mll}%`
                                              : challenge === "Swing"
                                              ? "10.00%"
                                              : alphaProVariant && alphaProVariant === 10 && fundingEval === "Alpha Pro"
                                              ? "10.00%"
                                              : alphaProVariant && alphaProVariant === 8 && fundingEval === "Alpha Pro"
                                              ? "8.00%"
                                              : alphaProVariant && alphaProVariant === 6 && fundingEval === "Alpha Pro"
                                              ? "6.00%"
                                              : challenges[challenge]?.[0]?.Max_Loss && challenges[challenge]?.[0]?.account_balance
                                              ? `${((challenges[challenge]?.[0]?.Max_Loss / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                              : "-"}
                                          </h4>
                                        </div>
                                      </div>

                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Max Daily Loss</p>
                                        </div>
                                        <div>
                                          <h4>
                                            {challenge === "Swing"
                                              ? "5.00%"
                                              : alphaProVariant && alphaProVariant === 10 && fundingEval === "Alpha Pro"
                                              ? "5.00%"
                                              : alphaProVariant && alphaProVariant === 8 && fundingEval === "Alpha Pro"
                                              ? "4.00%"
                                              : alphaProVariant && alphaProVariant === 6 && fundingEval === "Alpha Pro"
                                              ? "3.00%"
                                              : challenges[challenge]?.[0]?.Max_Daily_Loss && challenges[challenge]?.[0]?.account_balance
                                              ? `${((challenges[challenge]?.[0]?.Max_Daily_Loss / challenges[challenge]?.[0]?.account_balance) * 100).toFixed(2)}%`
                                              : "-"}
                                          </h4>
                                        </div>
                                      </div>

                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Profit Split</p>
                                        </div>
                                        <div>
                                          <h4>{challenges[challenge]?.[0]?.Profit_Split ? challenges[challenge]?.[0]?.Profit_Split + "%" : "-"}</h4>
                                        </div>
                                      </div>

                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          {selectedPayoutType === 1 ? <p>Bi Weekly Profit Split</p> : <p>On Demand Payout</p>}
                                        </div>
                                        <div>
                                          <h4>{challenges[challenge]?.[0]?.Bi_Weekly_Profit_Split || challenges[challenge]?.[0].plan_type === "Swing" ? "Yes" : "No"}</h4>
                                        </div>
                                      </div>

                                      <div className="dropdown-content_inner">
                                        <div>
                                          <img
                                            src={greenDot}
                                            alt="greenDot"
                                          />
                                          <p>Max Capital growth</p>
                                        </div>
                                        <div>
                                          <h4>{dollarUS(challenges[challenge]?.[0]?.Max_Capital_Growth / 1000 || 0) + "K"}</h4>
                                        </div>
                                      </div>
                                    </>
                                  </div>
                                </div>
                              )}
                            </label>
                          );
                        })}
                    </div>
                  </div>

                  {/* <>
                    <div className="dropdown-content_inner">
                      <div>
                        <img
                          src={greenDot}
                          alt="greenDot"
                        />
                        <p>Profit Target 1</p>
                      </div>
                      <div>
                        <h4>
                          {alphaProVariant === 10
                            ? "10.00%"
                            : alphaProVariant === 8
                            ? "8.00%"
                            : alphaProVariant === 6
                            ? "6.00%"
                            : challenges[challenge]?.[0]?.Evaluation_Phase_1 && challenges[challenge]?.[0]?.account_balance
                            ? `${((challenges[challenge][0].Evaluation_Phase_1 / challenges[challenge][0].account_balance) * 100).toFixed(2)}%`
                            : "-"}
                        </h4>
                      </div>
                    </div>

                    <div className="dropdown-content_inner">
                      <div>
                        <img
                          src={greenDot}
                          alt="greenDot"
                        />
                        <p>Max Loss</p>
                      </div>
                      <div>
                        <h4>
                          {alphaProVariant === 10
                            ? "10.00%"
                            : alphaProVariant === 8
                            ? "8.00%"
                            : alphaProVariant === 6
                            ? "6.00%"
                            : challenges[challenge][0].Max_Loss && challenges[challenge][0].account_balance
                            ? `${((challenges[challenge][0].Max_Loss / challenges[challenge][0].account_balance) * 100).toFixed(2)}%`
                            : "-"}
                        </h4>
                      </div>
                    </div>

                    <div className="dropdown-content_inner">
                      <div>
                        <img
                          src={greenDot}
                          alt="greenDot"
                        />
                        <p>Max Daily Loss</p>
                      </div>
                      <div>
                        <h4>
                          {alphaProVariant === 10
                            ? "5.00%"
                            : alphaProVariant === 8
                            ? "4.00%"
                            : alphaProVariant === 6
                            ? "3.00%"
                            : challenges[challenge][0].Max_Daily_Loss && challenges[challenge][0].account_balance
                            ? `${((challenges[challenge][0].Max_Daily_Loss / challenges[challenge][0].account_balance) * 100).toFixed(2)}%`
                            : "-"}
                        </h4>
                      </div>
                    </div>
                  </> */}

                  {fundingEval === "Alpha Pro" && (
                    <div className="platform alphaPro_tooltip">
                      <div className="heading">
                        <h1 style={{display: "flex", alignItems: "center", gap: "10px"}}>Assessment Target & Limits</h1>
                      </div>

                      {/* Tooltip */}
                      {showAlphaTooltip && (
                        <div
                          className="tooltip-box"
                          style={{position: "absolute", zIndex: 10}}
                        >
                          <div className="dropdown-content open">
                            {/* Profit Target 1 */}
                            <div className="dropdown-content_inner">
                              <div>
                                <img
                                  src={greenDot}
                                  alt="greenDot"
                                />
                                <p>Profit Target 1</p>
                              </div>
                              <div>
                                <h4>{alphaProVariant === 10 ? "10.00%" : alphaProVariant === 6 ? "6.00%" : "-"}</h4>
                              </div>
                            </div>

                            {/* Profit Target 2 */}
                            {/* <div className="dropdown-content_inner">
                              <div>
                                <img
                                  src={greenDot}
                                  alt="greenDot"
                                />
                                <p>Profit Target 2</p>
                              </div>
                              <div>
                                <h4>{alphaProVariant === 10 ? "5.00%" : alphaProVariant === 6 ? "6.00%" : "-"}</h4>
                              </div>
                            </div> */}

                            {/* Max Loss */}
                            <div className="dropdown-content_inner">
                              <div>
                                <img
                                  src={greenDot}
                                  alt="greenDot"
                                />
                                <p>Max Loss</p>
                              </div>
                              <div>
                                <h4>{alphaProVariant === 10 ? "10.00%" : alphaProVariant === 6 ? "6.00%" : "-"}</h4>
                              </div>
                            </div>

                            {/* Max Daily Loss */}
                            <div className="dropdown-content_inner">
                              <div>
                                <img
                                  src={greenDot}
                                  alt="greenDot"
                                />
                                <p>Max Daily Loss</p>
                              </div>
                              <div>
                                <h4>{alphaProVariant === 10 ? "5.00%" : alphaProVariant === 6 ? "3.00%" : "-"}</h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="platform_main">
                        {[6, 8, 10].map((variant) => (
                          <div
                            className="alphaPor_variants_div"
                            key={variant}
                            style={{position: "relative"}}
                          >
                            <label
                              onClick={() => setAlphaProVariant(variant)}
                              className={`platform_box ${alphaProVariant === variant ? "active_label selected_box" : ""}`}
                            >
                              <img
                                src={alphaProVariant === variant ? radioActiveBtn : radioBtn}
                                alt="radio"
                              />
                              <p style={{display: "flex", alignItems: "center", gap: "4px", width: "100%", justifyContent: "space-between"}}>
                                {variant}%
                                <img
                                  src={InfoIcon}
                                  alt="info"
                                  onMouseEnter={() => setHoveredAlphaProVariant(variant)}
                                  onMouseLeave={() => setHoveredAlphaProVariant(null)}
                                  style={{cursor: "pointer"}}
                                />
                              </p>
                            </label>

                            {hoveredAlphaProVariant === variant && <div className="tooltip-box">{renderLimits(variant)}</div>}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="accountSize">
                    <div className="account_balance_header">
                      <h2>Account size</h2>
                    </div>
                    {fundingEval === "Alpha Pro" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha Pro" in challenges &&
                          challenges["Alpha Pro"]?.map((balance, index) => {
                            // Show 6% if selected, show 8% if selected, and also show 8% when 10% is selected
                            const targetPercent = alphaProVariant === 10 ? 8 : alphaProVariant;
                            const isSelected = data?.challenge_id === balance?.id;

                            if (balance.profit_target_in_percent === targetPercent) {
                              console.log("balance", balance);
                              return (
                                <label
                                  key={balance.id}
                                  htmlFor={balance.amount}
                                  className={`amount_box ${isSelected ? "active_label selected_box" : ""}`}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      gap: "10px",
                                    }}
                                  >
                                    <img
                                      src={isSelected ? radioActiveBtn : radioBtn}
                                      alt="radio button"
                                    />

                                    <input
                                      type="radio"
                                      name="accoun_balance_value"
                                      id={balance.amount}
                                      onClick={(e) => {
                                        setSelectedAmountBox(e.target.checked ? index : null);
                                        setSelectedPrice(balance.Price);
                                        updateData("challenge_id", balance.id);
                                      }}
                                      onChange={() => setAccountBalance(balance.account_balance)}
                                      value={accountBalance}
                                      style={{display: "none"}}
                                    />

                                    <p>{dollarUS(balance?.account_balance || 0)}</p>
                                  </div>
                                </label>
                              );
                            }

                            return null;
                          })}
                      </div>
                    )}

                    {fundingEval === "Free Trial" && (
                      <div className="amount_list">
                        {challenges["Free Trial"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Swing" && (
                      <div className="amount_list">
                        {challenges["Swing"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance?.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Alpha Pro Plus" && (
                      <div className="amount_list">
                        {challenges["Alpha Pro Plus"]?.map((balance, index) => {
                          return (
                            <label
                              htmlFor={balance.amount}
                              className={
                                // selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                              }
                              // style={{
                              //   border:
                              //     selectedAmountFree === index
                              //       ? "1px solid #1395DC"
                              //       : "border: 1px solid var(--Box-Stroke-Gradient, rgba(184, 230, 255, 0.07))",
                              // }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  gap: "10px",
                                }}
                              >
                                {
                                  // selectedPrice === balance.Price ||
                                  data?.challenge_id === balance?.id ? (
                                    <img
                                      src={radioActiveBtn}
                                      alt="radioActiveBtn"
                                    />
                                  ) : (
                                    <img
                                      src={radioBtn}
                                      alt="radioBtn"
                                    />
                                  )
                                }
                                <input
                                  type="radio"
                                  name="accoun_balance_value"
                                  id={balance.amount}
                                  onClick={(e) => {
                                    setSelectedAmountFree(e.target.checked ? index : null);
                                    setSelectedPrice(balance.amount);
                                    updateData("challenge_id", balance.id);
                                  }}
                                  onChange={(e) => setAccountBalance(balance.account_balance)}
                                  value={accountBalance}
                                  style={{display: "none"}}
                                />
                                <p>{dollarUS(balance?.account_balance || 0)}</p>
                              </div>
                              {/* <p
                            className={
                              selectedAmountFree === index
                                ? "active_amount_value"
                                : "normal_amount_value"
                            }
                          >
                            {index === selectedAmountFree
                              ? dollarUS(balance.Price)
                              : dollarUS(balance.Price)}
                          </p> */}
                            </label>
                          );
                        })}
                      </div>
                    )}

                    {fundingEval === "Alpha One" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha One" in challenges &&
                          challenges["Alpha One"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}

                    {fundingEval === "Alpha X" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha X" in challenges &&
                          challenges["Alpha X"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}

                    {fundingEval === "Alpha Three" && (
                      <div className="amount_list">
                        {challenges &&
                          typeof challenges === "object" &&
                          "Alpha Three" in challenges &&
                          challenges["Alpha Three"]?.map((balance, index) => {
                            return (
                              <label
                                htmlFor={balance.amount}
                                className={
                                  // selectedPrice === balance?.Price ||
                                  data?.challenge_id === balance?.id ? "amount_box active_label selected_box" : "amount_box"
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "10px",
                                  }}
                                >
                                  {
                                    // selectedPrice === balance.Price ||
                                    data?.challenge_id === balance?.id ? (
                                      <img
                                        src={radioActiveBtn}
                                        alt="radioActiveBtn"
                                      />
                                    ) : (
                                      <img
                                        src={radioBtn}
                                        alt="radioBtn"
                                      />
                                    )
                                  }

                                  <input
                                    type="radio"
                                    name="accoun_balance_value"
                                    id={balance.amount}
                                    onClick={(e) => {
                                      setSelectedAmountBox(e.target.checked ? index : null);
                                      setSelectedPrice(balance.Price);
                                      // setSelectedChallengeDetails(balance);
                                      updateData("challenge_id", balance.id);
                                    }}
                                    onChange={(e) => setAccountBalance(balance.account_balance)}
                                    value={accountBalance}
                                    style={{display: "none"}}
                                  />
                                  <p>{dollarUS(balance?.account_balance || 0)}</p>
                                </div>
                                {/* <p
                              className={
                                selectedPrice === balance.Price ||
                                data?.challenge_id === balance?.id
                                  ? "active_amount_value"
                                  : "normal_amount_value"
                              }
                            >
                              {index === selectedAmountBox
                                ? dollarUS(balance.Price)
                                : dollarUS(balance.Price)}
                            </p> */}
                              </label>
                            );
                          })}
                      </div>
                    )}
                  </div>

                  <div
                    className="platform"
                    style={{paddingBottom: "50px"}}
                  >
                    <div className="account_balance_header">
                      <h2>Platform</h2>
                    </div>
                    <div className="platform_main">
                      {filteredPlatforms?.map((platform, index) => {
                        // if (selectedStep === 1 && platform === "DX Trade") return null;
                        // if (selectedStep === 3 && platform === "DX Trade") return null;
                        return (
                          <label
                            htmlFor={index}
                            className={index === selectedPlatformBox ? "platform_box active_label selected_box" : "platform_box"}
                            onClick={(e) => {
                              if ((FreeTrial || fundingEval === "Free Trial") && index === 1) return;
                              setSelectedPlatformBox(index);
                              setPlatformVal(platform.value);
                            }}
                            style={{pointerEvents: platform.disabled ? "none" : "auto"}}
                          >
                            {index === selectedPlatformBox ? (
                              <img
                                src={radioActiveBtn}
                                alt="radioActiveBtn"
                              />
                            ) : (
                              <img
                                src={radioBtn}
                                alt="radioBtn"
                              />
                            )}
                            <p>{platform.label}</p>

                            <input
                              type="radio"
                              name="platform_type"
                              id={index}
                              checked={selectedPlatformBox === index}
                              disabled={index === 1 && (FreeTrial || fundingEval === "Free Trial")}
                              style={{
                                filter: index === 1 && (FreeTrial || fundingEval === "Free Trial") ? "blur(3px)" : "",
                              }}
                            />
                            {platform.disabled && <div className="disabled-overlay">Coming Soon</div>}
                          </label>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <div className="secondStep">
                  <div className="confirm_order">
                    <div className="account_balance_header">
                      <h2>Payment Method</h2>
                    </div>
                    <div className="order_option">
                      <div
                        className="paymentMethodSelectorBox"
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "15px",
                          flexWrap: "wrap",
                        }}
                      >
                        <Dialog
                          sx={{
                            "& .MuiDialog-paper": {
                              width: "80%",
                              maxHeight: 435,
                              background: "#08131F",
                              borderRadius: "16px",
                              border: "1px solid #808080b5",
                            },
                          }}
                          maxWidth="xs"
                          // TransitionProps={{ onEntering: handleEntering }}
                          open={openCryptoOptionsBD}
                          // onClick={(e) => setOpenCryptoOptionsBD(false)}
                        >
                          <DialogTitle sx={{backgroundColor: "#01030c", color: "#fff"}}>Select Coin Payment method</DialogTitle>
                          <DialogContent
                            dividers
                            sx={{backgroundColor: "#01030c", color: "#fff"}}
                          >
                            {/* <RadioGroup
                    ref={radioGroupRef}
                    aria-label="crypto currencies"
                    name="cryptocurrency"
                    value={selectedCrypto}
                    onChange={(event) => {
                      setSelectedCrypto(event.target.value);
                    }}
                  >
                    {[
                      { label: "ETH", value: "ETH", icon: eth_icon },
                      { label: "USDT", value: "USDT.ERC20", usdt_icon },
                    ].map(({ label, value, icon }) => (
                      <FormControlLabel
                        label={label}
                        value={value}
                        key={value}
                        control={<Radio />}
                        sx={{
                          direction: "flex",
                          alignItems: "center",
                          gap: "20px",
                          height: "94px",
                          padding: "15px 20px",
                          border: "1px solid rgba(255, 255, 255, 0.09)",
                          marginBottom: "10px",
                          borderRadius: "10px",
                          flexDirection: "row-reverse",
                          justifyContent: "space-between",
                        }}
                      />
                    ))}
                  </RadioGroup> */}

                            <div className="options">
                              <div className="options_coins">
                                <div className="heading">
                                  <h1>Select Coin Payment method</h1>
                                  <img
                                    src={crossIcon}
                                    onClick={() => {
                                      setIsCoinMethodSelected(false);
                                      setOpenCryptoOptionsBD(false);
                                    }}
                                    alt="close modal"
                                  />
                                </div>
                                <div className="option_wrapper">
                                  {[
                                    {
                                      label: "USDT-TRON",
                                      value: "USDT.TRC20",
                                      icon: usd_icon,
                                      netWorkType: "NETWORK-TRON",
                                    },
                                    {
                                      label: "USDC-TRON",
                                      value: "USDC.TRC20",
                                      icon: usd_icon,
                                      netWorkType: "NETWORK-TRON",
                                    },
                                    {
                                      label: "COIN-ETH",
                                      value: "ETH",
                                      icon: eth_icon,
                                      netWorkType: "NETWORK-ETH",
                                    },
                                    {
                                      label: "COIN-USDT",
                                      value: "USDT.ERC20",
                                      icon: usdt_icon,
                                      netWorkType: "NETWORK-ETH",
                                    },
                                    {
                                      label: "COIN-USDC",
                                      value: "USDC",
                                      icon: usd_Coin,
                                      netWorkType: "NETWORK-ETH",
                                    },
                                  ]?.map(({label, value, icon, netWorkType}) => {
                                    return (
                                      <label
                                        htmlFor={label}
                                        className={value === selectedCrypto ? "optionC active_label selected_coin_method" : "optionC"}
                                        key={value}
                                      >
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            // paddingTop: "20px",
                                          }}
                                          className="coin-payment-methods"
                                        >
                                          <img
                                            src={icon}
                                            alt=""
                                            width="10%"
                                            className="coin_icon"
                                          />
                                          <p>{label}</p>
                                        </div>
                                        <div className="coinMethonEnd">
                                          <input
                                            type="radio"
                                            name="coin"
                                            id={label}
                                            ref={radioGroupRef}
                                            value={value}
                                            checked={value === selectedCrypto ? true : false}
                                            onChange={(event) => {
                                              setSelectedCrypto(event.target.value);
                                            }}
                                          />
                                          <p>{netWorkType}</p>
                                        </div>
                                      </label>
                                    );
                                  })}
                                </div>

                                <button
                                  className="confirm_btn"
                                  onClick={() => setOpenCryptoOptionsBD(false)}
                                >
                                  Confirm
                                </button>
                              </div>
                            </div>

                            <button className="confrim_btn">Confirm</button>
                          </DialogContent>
                        </Dialog>

                        <div
                          id="nuvei"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                          style={paymentMethod === "nuvei" ? {border: "1px solid #0d56eb"} : {border: "1px solid #b8e6ff12"}}
                        >
                          <label
                            htmlFor="nuvei-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={`${paymentMethod === "nuvei" ? "payments-active_new active_label" : ""}`}
                          >
                            <div
                              className="payment-logo-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "nuvei" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}
                              <input
                                type="radio"
                                id="nuvei-radio"
                                checked={paymentMethod === "nuvei"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>Nuvei</p>
                              </div>
                            </div>
                            <img
                              src={nuevi}
                              style={{height: "23px", width: "23px"}}
                              alt=""
                              className="payment-logo"
                            />
                          </label>

                          <div className="combined_payments">
                            <img
                              src={mastercard}
                              alt="mastercard"
                            />
                            <img
                              src={visa}
                              alt="visa"
                            />
                            {/* <img
                              src={diners}
                              alt="diners"
                            /> */}
                            <img
                              src={apple}
                              alt="apple"
                            />
                            <img
                              src={playStore}
                              alt="playStore"
                            />
                          </div>
                        </div>
                        {/* <div
                          id="nacepayment"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                        >
                          <label
                            htmlFor="nace-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={`${
                              paymentMethod === "nacepayment"
                                ? "payments-active_new active_label"
                                : ""
                            }`}
                          >
                            <div
                              className="payment-logo-container"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "nacepayment" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img src={radioBtn} alt="radioBtn" />
                              )}
                              <input
                                type="radio"
                                id="nace-radio"
                                checked={paymentMethod === "nacepayment"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>Nace</p>
                              </div>
                            </div>
                            <img
                              src={naceIcon}
                              style={{ height: "23px", width: "23px" }}
                              alt=""
                              className="payment-logo"
                            />
                          </label>
                        </div> */}
                        <div
                          id="coinspayment"
                          className="paymentMethods"
                          onClick={handlePaymentMethod}
                          // style={{background: "#070a12"}}
                        >
                          <label
                            htmlFor="coinspayment-radio"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minWidth: "213px",
                              justifyContent: "space-between",
                            }}
                            className={` ${paymentMethod === "coinspayment" ? "payments-active_new active_label" : ""}`}
                          >
                            <div
                              className="payment-logo-container coinspayment-logo-container"
                              style={{
                                display: "flex",
                                // flexDirection: "column",
                                alignItems: "center",
                                gap: "10px",
                                justifyContent: "space-between",
                              }}
                            >
                              {paymentMethod === "coinspayment" ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}
                              <input
                                type="radio"
                                id="coinspayment-radio"
                                checked={paymentMethod === "coinspayment"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "20px",
                                }}
                              >
                                <p>CoinPayments</p>
                              </div>
                            </div>
                            <img
                              src={coin_icon}
                              alt=""
                              className="payment-logo coinspayment-logo"
                            />
                          </label>

                          {/* {paymentMethod === "coinspayment" ? <span></span> : <></>} */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {selectedStep != 1 && (
                    <PayoutTypeSelector
                      payout_type={payout_type}
                      selectedPayoutType={selectedPayoutType}
                      setSelectedPayoutType={setSelectedPayoutType}
                      fundingEval={fundingEval}
                    />
                  )}

                  {/* <div className="payoutType">
                    <div className="account_balance_header">
                      <h2>Payout Type</h2>
                    </div>
                    <div className="payoutType_main">
                      {payout_type?.map((payoutType) => {
                        const isActive =
                          payoutType.value === selectedPayoutType;

                        return (
                          <label
                            key={payoutType.value}
                            htmlFor={`payout-${payoutType.value}`}
                            className={isActive ? "active_payout" : ""}
                            onClick={() =>
                              setSelectedPayoutType(payoutType.value)
                            }
                          >
                            <img
                              src={isActive ? radioActiveBtn : radioBtn}
                              alt={isActive ? "Selected" : "Not Selected"}
                            />
                            <p>{payoutType.name}</p>
                            <input
                              type="radio"
                              name="payoutType"
                              id={`payout-${payoutType.value}`}
                              checked={isActive}
                              disabled={isActive}
                            />
                          </label>
                        );
                      })}
                    </div>
                  </div> */}

                  <div className="commission_EA_use">
                    <div className="commission">
                      <div className="account_balance_header">
                        <h2>Commission</h2>
                      </div>

                      <div className="commission_inner">
                        {ac_type?.map((type, index) => {
                          return (
                            <label
                              htmlFor={type}
                              onClick={(e) => {
                                setSelectedAcType(index);
                              }}
                              className={selectedAcType === index ? "platform_box active_label selected_box" : "platform_box"}
                              // style={{
                              //   border:
                              //     selectedAcType === index
                              //       ? "1px solid #1395DC"
                              //       : "1px solid rgba(255, 255, 255, 0.09)",
                              // }}
                            >
                              {selectedAcType === index ? (
                                <img
                                  src={radioActiveBtn}
                                  alt="radioActiveBtn"
                                />
                              ) : (
                                <img
                                  src={radioBtn}
                                  alt="radioBtn"
                                />
                              )}

                              <p>{type}</p>
                              <input
                                type="radio"
                                name="platform"
                                id={type}
                                checked={selectedAcType === index}
                                // disabled
                              />
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    {/* {selectedPlatformBox !== 1 && selectedPlatformBox !== 2 ? ( */}
                    <div className="EA_use">
                      <div className="account_balance_header">
                        <h2>EA use</h2>
                      </div>

                      <div className="EA_use_inner">
                        <div
                          onClick={(e) => {
                            setUseEA(true);
                          }}
                          className={useEA ? "platform_box active_label" : "platform_box"}
                          // style={{
                          //   border: useEA
                          //     ? "1px solid #1395DC"
                          //     : "1px solid rgba(255, 255, 255, 0.09)",
                          // }}
                        >
                          {useEA ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}

                          <p>Yes</p>
                        </div>

                        <div
                          onClick={(e) => {
                            setUseEA(false);
                          }}
                          className={"platform_box " + (!useEA && "active_label selected_box")}
                          // style={{
                          //   border: !useEA
                          //     ? "1px solid #1395DC"
                          //     : "1px solid rgba(255, 255, 255, 0.09)",
                          // }}
                        >
                          {!useEA ? (
                            <img
                              src={radioActiveBtn}
                              alt="radioActiveBtn"
                            />
                          ) : (
                            <img
                              src={radioBtn}
                              alt="radioBtn"
                            />
                          )}
                          <p>No</p>
                        </div>
                      </div>

                      {/* {EA?.map((EA_text, index) => {
            return (
              <label
                htmlFor={EA_text + index}
                className={
                  useEA === index ? "platform_box selected_box" : "platform_box"
                }
              >
                <p>{EA_text}</p>
                <input
                  type="radio"
                  name="EA"
                  id={EA_text + index}
                  onClick={(e) => {
                    setUseEA(e.target.checked ? index : null);
                  }}
                  // disabled={index === 0}
                />
              </label>
            );
          })} */}
                    </div>
                    {/* ) : (<></>
                    )} */}
                  </div>

                  <div className="custom_info">
                    <div className="account_balance_header">
                      <h2>Customer Information</h2>
                    </div>
                    <div className="custom_info_inner">
                      <div style={{marginRight: "2px"}}>
                        <img
                          src={ProfileIcon}
                          alt="ProfileIcon"
                        />
                        <input
                          size="small"
                          placeholder="First Name *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          value={data ? data?.firstName : ""}
                          onChange={(e) => {
                            let value = e.target.value;
                            value = e.target.value.replace(/^\s+/, "");
                            value = value.replace(/[0-9]/g, "");
                            value = value.replace(/\s{2,}/g, " ");
                            updateData("firstName", value);
                          }}
                        />
                      </div>

                      <div style={{marginRight: "2px"}}>
                        <img
                          src={ProfileIcon}
                          alt="ProfileIcon"
                        />

                        <input
                          size="small"
                          placeholder="Last Name *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          value={data ? data?.lastName : ""}
                          onChange={(e) => {
                            let value = e.target.value;
                            value = e.target.value.replace(/^\s+/, "");
                            value = value.replace(/[0-9]/g, "");
                            value = value.replace(/\s{2,}/g, " ");

                            updateData("lastName", value);
                          }}
                        />
                      </div>

                      <div style={{marginRight: "2px"}}>
                        <img
                          src={EmailIcon}
                          alt="EmailIcon"
                        />
                        <input
                          size="small"
                          placeholder="Email *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                          }}
                          defaultValue={basicDetails ? basicDetails.email : ""}
                          value={data.email}
                          onChange={(e) => updateData("email", e.target.value.trim())}
                          onPaste={(e) => e.preventDefault()}
                        />
                        {validEmail && (
                          <>
                            <img
                              src={CheckSolidGreenIcon}
                              alt="CheckSolidGreenIcon"
                            />
                          </>
                        )}
                      </div>
                      <div style={{marginRight: "2px"}}>
                        <img
                          src={EmailIcon}
                          alt="EmailIcon"
                        />
                        <input
                          size="small"
                          placeholder="Confirm Email *"
                          fullWidth
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                            background: "transparent",
                          }}
                          defaultValue={basicDetails ? basicDetails.confirmEmail : ""}
                          value={data.confirmEmail}
                          onChange={(e) => updateData("confirmEmail", e.target.value.trim())}
                          onPaste={(e) => e.preventDefault()}
                        />
                        {validConfirmEmail && (
                          <>
                            <img
                              src={CheckSolidGreenIcon}
                              alt="CheckSolidGreenIcon"
                            />
                          </>
                        )}
                      </div>

                      <div style={{marginRight: "2px", marginBottom: "2px"}}>
                        <img
                          src={ContactNumber}
                          alt="Contact_number"
                        />
                        <input
                          size="small"
                          placeholder="Contact Number *"
                          fullWidth
                          type="text"
                          style={{
                            border: "1px solid rgb(255 255 255 / 33%);",
                            borderRadius: "10px",
                            appearance: "textfield",
                          }}
                          value={data?.contact}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only numeric input and enforce a max length of 15
                            if (/^\d*$/.test(value) && value.length <= 15) {
                              updateData("contact", value);
                            }
                          }}
                        />
                      </div>

                      {/* <div>
                    <img src={ContactNumber} alt="Password" />
                    <input
                      size="small"
                      placeholder="Password"
                      fullWidth
                      style={{
                        border: "1px solid rgb(255 255 255 / 33%);",
                        borderRadius: "10px",
                        background: "none !important",
                      }}
                      value={data?.pwd}
                      onChange={(e) => updateData("pwd", e.target.value)}
                    />
                  </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="nextBtn">
                <button
                  className={firstStepVisible ? "btnNext" : "BtnBack"}
                  onClick={() => setFirstStepVisible(!firstStepVisible)}
                >
                  {firstStepVisible ? "Next" : "Back"} <ArrowIcon />
                </button>
              </div>
              <div
                className="termsCondition"
                style={{width: "100%", height: "100%"}}
              >
                <p>Terms and Conditions</p>
                <div
                  className="zoomBtn"
                  onClick={() => setShowTNC(!showTNC)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt="Zoom"
                    />
                  </button>
                </div>
                <div className="termWrapper">
                  <PDFPreview
                    fileUrl={PDFDoc}
                    style={{height: "400px"}}
                    defaultScale={scale}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="customer_inforamtion">
          <div className="billingInfoTop">
            <div className="checkout_info_inner">
              <h2>Account Type</h2>
              <h3 className="planInfoBtn">
                {fundingEval}
                <button
                  className="dropdown-container_btn"
                  onMouseEnter={toggleDropdown}
                  onMouseLeave={() => setIsOpen(false)}
                >
                  <IbuttonIcon className={isOpen ? "" : ""} />
                  {isOpen && (
                    <div
                      className="dropdown-content open"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Leverage</p>
                        </div>
                        <div>
                          <h4>1:{currentChallenge?.Leverage}</h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Profit Target 1</p>
                        </div>
                        <div>
                          <h4>
                            {alphaProVariant && alphaProVariant === 10 && fundingEval === "Alpha Pro"
                              ? dollarUS((currentChallenge?.account_balance * 10) / 100)
                              : alphaProVariant && alphaProVariant === 6 && fundingEval === "Alpha Pro"
                              ? dollarUS((currentChallenge?.account_balance * 6) / 100)
                              : dollarUS(currentChallenge?.Evaluation_Phase_1)}
                          </h4>
                        </div>
                      </div>

                      {currentChallenge?.Evaluation_Phase_2 > 0 && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Target 2</p>
                          </div>
                          <div>
                            <h4>
                              {alphaProVariant && alphaProVariant === 10 && fundingEval === "Alpha Pro"
                                ? dollarUS((currentChallenge?.account_balance * 5) / 100)
                                : alphaProVariant && alphaProVariant === 6 && fundingEval === "Alpha Pro"
                                ? dollarUS((currentChallenge?.account_balance * 6) / 100)
                                : dollarUS(currentChallenge?.Evaluation_Phase_2)}
                            </h4>
                          </div>
                        </div>
                      )}

                      {currentChallenge?.Evaluation_Phase_3 > 0 && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Target 3</p>
                          </div>
                          <div>
                            <h4>{dollarUS(currentChallenge?.Evaluation_Phase_3)}</h4>
                          </div>
                        </div>
                      )}

                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          {fundingEval === "Alpha One" ? <p>Trailing MLL</p> : <p>Max Loss</p>}
                        </div>
                        <div>
                          <h4>
                            {fundingEval === "Alpha One" && currentChallenge?.trailing_mll !== 0
                              ? `${currentChallenge?.trailing_mll}%`
                              : fundingEval === "Alpha Pro" && alphaProVariant && alphaProVariant === 10
                              ? dollarUS((currentChallenge?.account_balance * 10) / 100)
                              : fundingEval === "Alpha Pro" && alphaProVariant && alphaProVariant === 6
                              ? dollarUS((currentChallenge?.account_balance * 6) / 100)
                              : dollarUS(currentChallenge?.Max_Loss)}
                          </h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Max Daily Loss</p>
                        </div>
                        <div>
                          <h4>
                            {fundingEval === "Alpha Pro" && alphaProVariant && alphaProVariant === 10
                              ? dollarUS((currentChallenge?.account_balance * 5) / 100)
                              : fundingEval === "Alpha Pro" && alphaProVariant && alphaProVariant === 6
                              ? dollarUS((currentChallenge?.account_balance * 3) / 100)
                              : dollarUS(currentChallenge?.Max_Daily_Loss)}
                          </h4>
                        </div>
                      </div>
                      {fundingEval !== "Free Trial" && (
                        <div className="dropdown-content_inner">
                          <div>
                            <img
                              src={greenDot}
                              alt="greenDot"
                            />
                            <p>Profit Split</p>
                          </div>
                          <div>
                            <h4>{currentChallenge?.Profit_Split === "N/A" ? "-" : `${currentChallenge?.Profit_Split}%`}</h4>
                          </div>
                        </div>
                      )}
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          {selectedPayoutType === 1 ? <p>Bi Weekly Profit Split</p> : <p>On Demand Payout</p>}
                        </div>
                        <div>
                          <h4>{currentChallenge?.Bi_Weekly_Profit_Split ? "Yes" : "No"}</h4>
                        </div>
                      </div>
                      <div className="dropdown-content_inner">
                        <div>
                          <img
                            src={greenDot}
                            alt="greenDot"
                          />
                          <p>Max Capital growth</p>
                        </div>
                        <div>
                          <h4>{dollarUS(currentChallenge?.Max_Capital_Growth) || "-"}</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </button>
              </h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Step</h2>
              <h3>{selectedStep}</h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Account Size</h2>
              <h3>{dollarUS(accountBalance || 0)}</h3>
            </div>
            <div className="checkout_info_inner">
              <h2>Platform</h2>
              <h3>{platformVal}</h3>
            </div>
          </div>

          <div onClick={toggleDropdown}>
            {/* <button className="see_more">
              <h2>{isOpen ? fundingEval : <p>See More</p>}</h2>
              <img
                src={dropdownArrow}
                alt="dropdownArrow"
                className={`${isOpen ? "dropdownArrow_rotate" : ""}`}
              />
            </button> */}
          </div>

          <div className="discount">
            {fundingEval === "Free Trial" ? (
              ""
            ) : (
              <>
                {" "}
                <h2>Discount</h2>
                <div className="couponLine">
                  <div className="inputHolder discount_input">
                    <input
                      className="discount_input"
                      placeholder="Enter Coupon Code"
                      type="text"
                      value={coupon.value}
                      // disabled={Number(checkout.final_price) === 0 ? true : false}
                      onBlur={(e) => validateCouponCode()}
                      onChange={(e) =>
                        setCoupon((prevState) => ({
                          ...prevState,
                          value: e.target.value,
                        }))
                      }
                      style={coupon.error ? {border: "2px solid #fd2d2d"} : {}}
                      disabled={couponValue ? true : false}
                    />
                    {coupon.error ? (
                      <small
                        style={{
                          color: "#fd2d2d",
                          textAlign: "left",
                          float: "left",
                          fontFamily: "sans-serif",
                        }}
                      >
                        {coupon?.error}
                      </small>
                    ) : (
                      <></>
                    )}
                    <button
                      onClick={validateCouponCode}
                      className={couponValue ? "applied" : ""}
                      disabled={couponValue || buttonSpinner}
                    >
                      {buttonSpinner ? (
                        <CircularProgress
                          size={14}
                          style={{color: "white"}}
                        />
                      ) : couponValue ? (
                        "Applied"
                      ) : (
                        "Apply Code"
                      )}
                    </button>
                  </div>
                  {couponValue ? (
                    <div className="couponValue">
                      <p>{couponValue}</p>
                      <img
                        src={clearicon}
                        alt="clearicon"
                        onClick={() => {
                          setCoupon({value: "", error: false});
                          setCouponValue(null);
                          setCheckout((prevState) => ({
                            ...prevState,
                            discount: 0,
                            final_price: prevState.price,
                          }));
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </>
            )}

            <div className="calculate_price_with_discount">
              <div>
                <h2>{fundingEval}</h2>

                {/* <p>${dollarUS(accountBalance)}</p> */}
                <p>{dollarUS(challengePrice || 0)} </p>
              </div>
              {/* {checkout?.discount > 0 ? (
              <div>
                <h2>Discount</h2>
                <p>{checkout?.discount}</p>
              </div>
            ) : (
              ""
            )} */}

              {checkout?.discount && checkout?.discount !== 0 && !coupon.error ? (
                <div>
                  <h2>Discount</h2>
                  <p>
                    {coupon.error ? "" : "-"} {dollarUS(checkout?.discount)}
                  </p>
                </div>
              ) : null}

              <div className="final_price">
                <p>Total</p>
                <p>
                  {/* {couponValue
                    ? coupon.error
                      ? dollarUS(checkout?.final_price || 0)
                      : dollarUS(checkout?.final_price || 0)
                    : coupon.error
                    ? dollarUS(currentChallenge?.Price || 0)
                    : dollarUS(currentChallenge?.Price || 0)} */}
                  {couponValue ? dollarUS(checkout?.final_price || 0) : dollarUS(challengePrice || 0)}
                </p>
              </div>
            </div>
            <span>By confirming the order:</span>

            <div className="term_and_conditions">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isChecked.tnc}
                    onChange={(e) => setIsChecked({...isChecked, tnc: e.target.checked})}
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={
                  <p>
                    I declare that I have read and agree with
                    <span
                      onClick={() => setShowTNC(true)}
                      style={{color: "#1f69ff", cursor: "pointer"}}
                    >
                      {" "}
                      Terms & Conditions, Privacy Policy, General Service Agreement.*
                    </span>
                  </p>
                }
              />
              {countryCheck === "US" || platformVal === "DX Trade" || platformVal === "TradeLocker" || platformVal === "C Trader" ? (
                <></>
              ) : (
                <FormControlLabel
                  control={
                    <Checkbox
                      value={isChecked.not_us_resident}
                      onChange={(e) =>
                        setIsChecked({
                          ...isChecked,
                          not_us_resident: e.target.checked,
                        })
                      }
                      sx={{marginTop: "0px", borderRadius: "4px"}}
                    />
                  }
                  label={<p>I'm not a US resident or citizen.*</p>}
                />
              )}

              <FormControlLabel
                control={
                  <Checkbox
                    value={isChecked.acknowledge_personal_data}
                    onChange={(e) =>
                      setIsChecked({
                        ...isChecked,
                        acknowledge_personal_data: e.target.checked,
                      })
                    }
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={<p>I acknowledge that signing up with personal details that do not match my ID/Password information, will lead to suspension of my payout(s) and closure of my account(s).*</p>}
              />

              {/* <FormControlLabel
                control={
                  <Checkbox
                    value={isChecked.agree_to_news_letters}
                    onChange={(e) =>
                      setIsChecked({
                        ...isChecked,
                        agree_to_news_letters: e.target.checked,
                      })
                    }
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={<p>I agree to receive news letters, news and product updates.</p>}
              /> */}
              {/* <FormControlLabel
                control={
                  <Checkbox
                    value={isChecked.marketing_opt_in}
                    onChange={(e) =>
                      setIsChecked({
                        ...isChecked,
                        marketing_opt_in: e.target.checked,
                      })
                    }
                    sx={{marginTop: "0px", borderRadius: "4px"}}
                  />
                }
                label={<p>Send me an exclusive welcome offer, trader insights, product updates and discounts from Alpha Capital Group by email. You can unsubscribe at any time. </p>}
              /> */}
            </div>
          </div>
          {firstStepVisible === false ? (
            <CustomLoadingButton
              disabled={confirmPaymentClick}
              onClick={handleFinalPayment}
              loading={confirmPaymentClick}
              className="proceed_btn"
              text="Proceed"
              sx={{color: "white"}}
              endIcon={false}
            />
          ) : (
            ""
          )}
        </div>
        <TncModal
          open={showTNC}
          onClose={() => setShowTNC(false)}
        />
      </div>

      {isCoindMethodSelected && <CoinPaymentOption setIsCoinMethodSelected={setIsCoinMethodSelected} />}
    </div>
  );
};

export default CheckoutSection;

const CoinPaymentOption = ({setIsCoinMethodSelected}) => {
  const [selectedBox, setSelectedBox] = useState(0);
  const coindPayments = [
    {
      // icon: bitCoinIcon,
      name: "Bitcoins",
    },
    {
      // icon: bitCoinIcon,
      name: "Lorem",
    },
    {
      // icon: bitCoinIcon,
      name: "Lorems",
    },
  ];

  return (
    <div className="options">
      <div className="options_coins">
        <div className="heading">
          <h1>Select Coin Payment method</h1>
          <img
            src={crossIcon}
            onClick={() => setIsCoinMethodSelected(false)}
          />
        </div>
        {coindPayments?.map((option, index) => {
          return (
            <label
              htmlFor={option.name}
              className={selectedBox === index ? "optionC selected_coin_method" : "optionC"}
            >
              <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                <img
                  src={option.icon}
                  alt=""
                />
                <p>{option.name}</p>
              </div>
              <input
                type="radio"
                name="coin"
                id={option.name}
                onClick={(e) => setSelectedBox(e.target.checked ? index : null)}
              />
            </label>
          );
        })}
        <button
          className="confirm_btn"
          onClick={() => setIsCoinMethodSelected(false)}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export const TncModal = ({open, onClose}) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 600) {
        setScale(0.5);
      } else if (screenWidth < 750) {
        setScale(0.8);
      } else {
        setScale(1.2);
      }
    };

    updateScale(); // Set on initial load
    window.addEventListener("resize", updateScale);

    return () => window.removeEventListener("resize", updateScale);
  }, []);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Terms & Conditions"
      width={800}
      bodyStyle={{padding: 0}}
      centered
      className="termsConditionModal"
    >
      <PDFPreview
        fileUrl={PDFDoc}
        defaultScale={scale}
        style={{height: "80vh", width: "100%"}}
      />
    </Modal>
  );
};
